import { createRouter } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { rootRoute } from './routes/__root';
import { Route as homeRoute } from './routes/index';
import { Route as loginRoute } from './routes/login';
import { Route as registerRoute } from './routes/register';
import { itemsRoute } from './routes/items/route';
import { Route as itemDetailRoute } from './routes/items/$itemId';
import { myPageRoute } from './routes/my-page/route';
import { Route as myPageFavoritesRoute } from './routes/my-page/favorites';
import { getSiteBasepath } from './lib/site-paths';

export function createAppRouter(queryClient: QueryClient) {
  const routeTree = rootRoute.addChildren([
    homeRoute,
    loginRoute,
    registerRoute,
    itemsRoute.addChildren([itemDetailRoute]),
    myPageRoute.addChildren([myPageFavoritesRoute]),
  ]);

  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    basepath: getSiteBasepath(),
  });
}
